<template>
  <div class="gaming-header">
    <div class="header-wrap">
      <div class="gaming-date-wrap">
        <div class="gaming-date">
          <button @click="goRouter('gaming')" :class="{ 'active': routerName === 'gaming' }">全部</button>
          <button @click="goRouter('completed')" :class="{ 'active': routerName === 'completed' }">完赛</button>
          <button @click="goRouter('schedule')" :class="{ 'active': routerName === 'schedule' }">赛程</button>
          <button @click="goRouter('collect')" :class="{ 'active': routerName === 'collect' }">收藏</button>
        </div>
      </div>
      <div class="gaming-type-wrap">
        <div class="gaming-type">
          <button class="lol" :class="{ 'active': currentGame === 'lol' }" @click="changeGame('lol')"></button>
          <button class="dota" :class="{ 'active': currentGame === 'dota2' }" @click="changeGame('dota2')"></button>
          <button class="csgo" :class="{ 'active': currentGame === 'csgo' }" @click="changeGame('csgo')"></button>
          <button class="kog" :class="{ 'active': currentGame === 'kog' }" @click="changeGame('kog')"></button>
          <el-popover v-model="filterShow" placement="bottom" width="340" popper-class="gaming-filter-wrap"
            trigger="click">
            <div class="filter-wrap">
              <p>赛事筛选</p>
              <div class="filter-content">
                <ul>
                  <li class="league-item" v-for="(item, idx) in league.list" :key="`league-${idx}-${item.league_id}`">
                    <div class="checkbox">
                      <input type="checkbox" :id="`league-${item.league_id}`"
                        :checked="checkedLeague.includes(item.league_id)" @change="changeLeagueSelect($event, item)">
                      <label :class="{ 'checked': checkedLeague.includes(item.league_id) }"
                        :for="`league-${item.league_id}`"></label>
                    </div>
                    <label class="name" :for="`league-${item.league_id}`">
                      <span class="txt">{{ item.name }}</span>
                      <span class="num">[{{ item.num }}]</span>
                    </label>
                  </li>
                </ul>
              </div>
              <div class="bottom">
                <div class="left">
                  <button @click="selectAll">全选</button>
                  <button @click="reverseSelect">反选</button>
                </div>
                <div class="right">
                  <span>已选 {{ selectedNum }} / {{ league.data.num || 0 }} 场</span>
                  <button @click="filterSubmit">确定</button>
                </div>
              </div>
            </div>
            <button slot="reference" class="filter">赛事筛选</button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="header-date" v-if="['completed', 'schedule'].includes(routerName)">
      <div class="date-btn">
        <div class="date-btn-txt">
          <img src="../../assets/images/gaming/date-icon.png" alt="">
          <span>日历</span>
        </div>
        <el-date-picker v-model="activeDate" type="date" placeholder="" value-format="yyyy/MM/dd" :editable="false"
          popper-class="picker-date" :pickerOptions="pickerOptions" @change="switchDate">
        </el-date-picker>
      </div>
      <div class="date-list">
        <div class="date-item" v-for="(date, idx) in formDate" :key="`${date}-${idx}`"
          :class="{ 'active': activeDate === date }" @click="switchDate(date)">
          <p>{{ date | formateDate }}</p>
          <p>{{ date | formateWeek }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn")

export default {
  name: "GamingHeader",
  data() {
    return {
      filterShow: false,
      pickerDate: '',
      activeDate: '',
      league: {
        data: {},
        list: []
      },
      checkedLeague: []
    }
  },
  computed: {
    isTest() {
      return ['localhost', 'dev-web.gqj1.tv', 'test-web.gqj1.tv'].includes(location.hostname)
    },
    currentGame() {
      return (this.$route.params.type || 'dota2').toLowerCase()
    },
    selectedNum() {
      const selectedArr = (this.league.list || []).filter(item => this.checkedLeague.includes(item.league_id))
      const total = selectedArr.reduce((prep, curr, idx, arr) => {
        return prep + curr.num
      }, 0)
      return total
    },
    routerName() {
      return this.$route.name
    },
    formDate() {
      let date = []
      if (this.routerName === 'completed') {
        date = [...Array(7).keys()].map(days => {
          let t = new Date(Date.now() - 86400000 * days);
          let str = dayjs(t).format('YYYY/MM/DD');
          return str;
        }).reverse()
      } else if (this.routerName === 'schedule') {
        date = [...Array(7).keys()].map(days => {
          let t = new Date(Date.now() + 86400000 * days);
          // `${t.getFullYear()}/${t.getMonth() + 1}/${t.getDate()}`
          let str = dayjs(t).format('YYYY/MM/DD');
          return str;
        })
      }
      return date
    },
    pickerOptions() {
      if (this.routerName === 'completed') {
        return {
          disabledDate(time) {
            let today = (new Date(dayjs().format('YYYY/MM/DD'))).getTime();
            let one = 30 * 24 * 3600 * 1000;
            let oneMonths = today - one;
            return time.getTime() > today || time.getTime() < oneMonths
          }
        }
      }
      if (this.routerName === 'schedule') {
        return {
          disabledDate(time) {
            let today = (new Date(dayjs().format('YYYY/MM/DD'))).getTime();
            let one = 30 * 24 * 3600 * 1000;
            let oneMonths = today + one;
            return time.getTime() < today || time.getTime() > oneMonths
          }
        }
      }
    }
  },
  filters: {
    formateDate(val) {
      const str = dayjs(new Date()).format('YYYY/MM/DD')
      return val === str ? '今天' : dayjs(val).format('MM/DD')
    },
    formateWeek(val) {
      return dayjs(val).format('dddd')
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.type !== from.params.type || to.query.day !== from.query.day || (to.name !== from.name && to.name !== 'collect')) {
        if ((to.name !== from.name && to.name !== 'collect')) {
          this.activeDate = dayjs(new Date()).format('YYYY/MM/DD')
        }
        this.getLeagueList()
      }
    }
  },
  methods: {
    changeGame(type) {
      const query = {}
      if (this.$route.query && this.$route.query.day) {
        query.day = this.$route.query.day
      }
      this.$router.push({
        name: this.$route.name,
        params: {
          type: type
        },
        query
      })
    },
    getLeagueList() {
      const type = (this.$route.params.type || '').toLowerCase()
      let day = this.$route.query.day
      if (['completed', 'schedule'].includes(this.$route.name)) {
        day = this.$route.query.day || dayjs(new Date()).format('YYYYMMDD')
      }
      let query = `?type=${type}`
      if (day) {
        query = `${query}&day=${day}`
      }
      axios.get(COMMOND.NEW_BASE_URL + 'getesports_league' + query).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.league = res.data.data
          this.selectAll(true, 'emit')
        }
      })
    },
    selectAll(isAll, type) {
      const selectedArr = []
      if (isAll) {
        this.league.list.forEach((league) => {
          selectedArr.push(league.league_id)
        })
      }
      this.checkedLeague = selectedArr
      if (type === 'emit') {
        this.$emit('update', this.checkedLeague)
      }
    },
    reverseSelect() {
      const allId = this.league.list.map((item) => { return item.league_id })
      const reverseList = allId.filter(item => !this.checkedLeague.includes(item))
      this.checkedLeague = reverseList
    },
    changeLeagueSelect(e, league) {
      const selectedTmp = Array.from(new Set(this.checkedLeague))
      const isCheck = e.target.checked
      if (isCheck) {
        selectedTmp.push(league.league_id)
      } else {
        const idx = selectedTmp.indexOf(league.league_id)
        if (idx > -1) selectedTmp.splice(selectedTmp.indexOf(league.league_id), 1)
      }
      this.checkedLeague = Array.from(new Set(selectedTmp))
    },
    filterSubmit() {
      this.$emit('update', this.checkedLeague)
      this.filterShow = false
    },
    goRouter(type) {
      if (this.$route.name !== type) {
        const query = {}
        if (this.$route.query && this.$route.query.day && !['gaming', 'collect'].includes(type)) {
          query.day = this.$route.query.day
        }
        this.$router.push({
          name: type,
          params: {
            type: this.$route.params.type
          },
          query
        })
      }
    },
    switchDate(date) {
      this.activeDate = date
      this.$router.push({
        name: this.$route.name,
        params: {
          type: this.$route.params.type
        },
        query: {
          day: date.replaceAll('/', '')
        }
      })
    }
  },
  mounted() {
    this.getLeagueList()
    if (this.$route.query && this.$route.query.day) {
      this.activeDate = dayjs(this.$route.query.day, 'YYYYMMDD').format('YYYY/MM/DD')
    } else {
      this.activeDate = dayjs(new Date()).format('YYYY/MM/DD')
    }
  }
}
</script>

<style lang="less" scoped>
.header-wrap {
  display: flex;
  justify-content: space-between;

  .gaming-date-wrap {
    display: flex;
    align-items: center;
  }

  .gaming-date {
    display: flex;
    gap: 30px;

    button {
      width: 90px;
      height: 32px;
      border-radius: 5px;
      border: none;
      outline: none;
      font-size: 14px;
      color: #4B5B76;
      background: transparent;
      cursor: pointer;

      &.active {
        background: #C9353F;
        color: #fff;
      }
    }
  }

  .gaming-type {
    display: flex;
    gap: 10px;

    button {
      width: 106px;
      height: 46px;
      border: none;
      outline: none;
      cursor: pointer;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: transparent;

      &.dota {
        background-image: url('../../assets/images/gaming/dota-nor.png');

        &.active {
          background-image: url('../../assets/images/gaming/dota-pre.png');
        }
      }

      &.lol {
        background-image: url('../../assets/images/gaming/lol-nor.png');

        &.active {
          background-image: url('../../assets/images/gaming/lol-pre.png');
        }
      }

      &.csgo {
        background-image: url('../../assets/images/gaming/csgo-nor.png');

        &.active {
          background-image: url('../../assets/images/gaming/csgo-pre.png');
        }
      }

      &.kog {
        background-image: url('../../assets/images/gaming/kog-nor.png');

        &.active {
          background-image: url('../../assets/images/gaming/kog-pre.png');
        }
      }
    }

    .filter {
      width: 106px;
      height: 46px;
      border: none;
      outline: none;
      background: #C9353F;
      color: #fff;
      font-size: 14px;
      border-radius: 5px;
      line-height: 46px;
      text-align: center;
    }
  }
}

.header-date {
  display: flex;
  gap: 23px;
  margin-top: 20px;

  .date-btn {
    width: 147px;
    border: 1px solid #E0E0E0;
    border-radius: 5px;
    height: 62px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .date-btn-txt {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;

      img {
        width: 18px;
      }
    }

    /deep/ .el-date-editor.el-input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
    }

    /deep/ .el-input--prefix .el-input__inner {
      opacity: 0;
      height: 100%;
      cursor: pointer;
    }

    /deep/ .el-input__icon {
      opacity: 0;
    }
  }

  .date-list {
    display: flex;
    flex: 1;
    border: 1px solid #E0E0E0;
    border-radius: 5px;
    background: #fff;
    overflow: hidden;

    .date-item {
      flex: 1;
      height: 62px;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;
      font-size: 14px;
      background: #fff;
      border-right: 1px solid #E0E0E0;
      cursor: pointer;

      &:last-child {
        border: none;
      }

      &.active {
        background: #E65668;
        color: #fff;
      }
    }
  }
}
</style>

<style lang="less">
.gaming-filter-wrap {
  .filter-wrap {
    p {
      text-align: center;
      font-size: 16px;
      line-height: 22px;
    }

    .filter-content {
      height: 260px;
      overflow-y: auto;
      padding: 10px;

      ul {
        display: flex;
        flex-wrap: wrap;

        .league-item {
          width: 100%;
          padding: 10px 0;
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;

          &:hover {
            .name {
              color: #db4a48;

              .num {
                color: #db4a48;
              }
            }
          }

          .checkbox {
            width: 20px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: space-around;

            input {
              display: none;
            }

            label {
              display: block;
              width: 12px;
              height: 12px;
              cursor: pointer;
              position: relative;

              &::after {
                content: ' ';
                position: absolute;
                width: 16px;
                height: 16px;
                border: 1px solid #939393;
                top: -3px;
                left: -2px;
                border-radius: 50%;
              }

              &.checked {
                &::after {
                  border: 1px solid #db4a48;
                }

                &::before {
                  content: "";
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  position: absolute;
                  background: #db4a48;
                  left: 0;
                  top: -1px;
                }
              }
            }
          }

          .name {
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            display: flex;

            .txt {
              width: 230px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            .num {
              color: #b1b1b1;
            }
          }
        }
      }
    }

    .bottom {
      height: 35px;
      padding: 5px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        gap: 10px;

        button {
          border: none;
          background-color: transparent;
          outline: none;
          font-size: 14px;
          height: 30px;
          padding: 0 10px;
          cursor: pointer;
        }
      }

      .right {
        display: flex;
        gap: 10px;
        align-items: center;

        button {
          border-radius: 5px;
          width: 64px;
          height: 30px;
          border: none;
          background: #C9353F;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style>
.picker-date .el-date-table td.current:not(.disabled) span {
  background-color: #C9353F;
  color: #fff;
}

.picker-date .el-date-table td.today span {
  color: #C9353F;
}

.picker-date .el-date-table td.available:hover {
  color: #C9353F;
}

.picker-date .el-picker-panel__icon-btn:hover {
  color: #C9353F;
}

.picker-date .el-date-picker__header-label.active,
.picker-date .el-date-picker__header-label:hover {
  color: #C9353F;
}

.picker-date .el-year-table td.today .cell {
  color: #C9353F;
}

.picker-date .el-year-table td .cell:hover,
.picker-date .el-year-table td.current:not(.disabled) .cell {
  color: #C9353F;
}

.picker-date .el-month-table td.today .cell {
  color: #C9353F;
}

.picker-date .el-month-table td.current:not(.disabled) .cell {
  color: #C9353F;
}

.picker-date .el-month-table td .cell:hover {
  color: #C9353F;
}

.picker-date .el-year-table td .cell:hover,
.picker-date .el-year-table td.current:not(.disabled) .cell {
  color: #C9353F;
}
</style>
